import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { LegendTypeEnum } from '@eview/core/domain/post/post';

@Component({
  selector: 'map-legend',
  templateUrl: 'map-legend.component.html',
  styleUrls: ['map-legend.component.scss']
})
export class MapLegendComponent implements OnInit, OnChanges {

  @Input() private categoriesList;
  @Input() private categoriesData;
  @Input() public viewOnlyMode;
  @Input() private statusData;
  @Output() public onCloseClick: EventEmitter<any> = new EventEmitter();
  @Output() public onLegendModeChange = new EventEmitter<string>();

  selectedLegendData: any = [];

  constructor() {
  }

  /** Muestra Categorías / Estados solo cuando hay leyenda de categorías que elegir. */
  get showCategoryModeSelector(): boolean {
    return Array.isArray(this.categoriesData) && this.categoriesData.length > 0;
  }

  ngOnInit(): void {
    this.syncLegendBody();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categoriesData'] || changes['categoriesList'] || changes['viewOnlyMode']) {
      this.syncLegendBody();
    }
  }

  private syncLegendBody(): void {
    if (!this.viewOnlyMode) {
      this.selectedLegendData = this.categoriesData ?? [];
      return;
    }
    if (!this.showCategoryModeSelector) {
      this.selectedLegendData = this.statusData ?? [];
      return;
    }
    const checkedCategory = this.categoriesList?.filter((obj: any) => obj.checked === true) ?? [];
    if (checkedCategory.length) {
      this.applyLegendType(checkedCategory[0].value);
    } else {
      this.applyLegendType(LegendTypeEnum.status);
    }
  }

  radioChange(value: string): void {
    this.applyLegendType(value);
    this.onLegendModeChange.emit(value);
  }

  private applyLegendType(value: string): void {
    if (value === LegendTypeEnum.categories) {
      this.selectedLegendData = this.categoriesData;
    } else {
      this.selectedLegendData = this.statusData;
    }
  }
}
